import React from 'react';
import { styles } from './SlideoutLayoutSection.css';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
export type SlideoutLayoutSectionProps = {
  heading?: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
};

export const SlideoutLayoutSection = ({ heading, icon = null, children }: SlideoutLayoutSectionProps) => {
  const isMobile = useBreakpoint('md', 'down');
  const headingHandleSuffix = heading
    ? `-${heading
        .replace(/[^A-Za-z0-9-]/g, '-')
        .replace(/-+/g, '-')
        .toLowerCase()}`
    : '';

  return (
    <div className={styles.layoutBox} data-testid={`slideout-layout-heading${headingHandleSuffix}`}>
      {heading ? (
        <CalloutFont
          as={isMobile ? 'h3' : 'h2'}
          className={styles.heading}
          testId={`slideout-layout-heading-title${headingHandleSuffix}`}
        >
          {icon} {heading}
        </CalloutFont>
      ) : null}
      {children}
    </div>
  );
};
